import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

/**
 * About page component that explains the purpose and methodology of the news aggregator
 */
const About: React.FC = () => {
  return (
    <div className="app">
      <header className="header about-header">
        <h1>ABOUT OUR NEWS AGGREGATOR</h1>
        <Link to="/" className="back-link">← BACK TO NEWS</Link>
      </header>
      
      <main className="about-content">
        <section className="about-section">
          <h2>WHY WE DO IT</h2>
          <p>
            In today's fast-paced digital world, news consumption has become increasingly complex, 
            with flashy websites, autoplay videos, and intrusive advertisements competing for your attention.
          </p>
          <p>
            We believe in returning to the fundamentals of news delivery: clear, concise text that 
            allows readers to quickly scan headlines and decide what matters to them without distraction.
          </p>
          <p>
            Our old-school approach is inspired by pioneering news aggregators that prioritized 
            content over presentation, focusing on what truly matters - the news itself.
          </p>
        </section>
        
        <section className="about-section">
          <h2>HOW WE DO IT</h2>
          <p>
            Our approach is deliberately minimalist:
          </p>
          <ul className="about-list">
            <li>We use a simple, text-based interface with no animations or heavy graphics</li>
            <li>Content is organized into clear categories for easy navigation</li>
            <li>Important stories are highlighted in red to draw attention</li>
            <li>The site loads quickly, even on slower connections</li>
            <li>We focus on headlines, allowing you to click through to source articles for details</li>
          </ul>
          <p>
            We manually curate all content, selecting stories based on significance rather than 
            sensationalism, ensuring you get a balanced view of current events.
          </p>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default About; 